import moment from "moment"
import React, { useState } from "react"
import { Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import IconEdit from '../../../assets/images/icon-edit.png'
import Select from 'react-select'
import { useHistory } from "react-router"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import { Link } from "react-router-dom"

const OrderAddInfo = (props:any) => {
    const {data, setData, type, onlyView, orderSource} = props
    const router = useHistory()
    const [modalIsOpen, setIsOpen] = useState(false);
    
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if(value?.length > 1000) return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
            setData({
                ...data,
                customer_id: {
                    ...data?.customer_id,
                    phone: value
                }
            })
        }
        else {
            setData({
                ...data,
                [name]: value
            })
        }
        
    }

    return (
        <>
            <PageBody>
                <div className="nutri-title mb-3">Thông tin đơn hàng</div>
                <Row>
                    <Col md={5} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Nguồn đơn</Label>
                            <InputGroup>
                                <Select
                                    placeholder={type === 'view' && !data?.ordersource_id ? '---' : "Chọn nguồn đơn"}
                                    className="react-select select-icon"
                                    classNamePrefix="react-select"
                                    maxMenuHeight={250}
                                    isDisabled={onlyView}
                                    onChange={(val: any) => {
                                        setData({
                                            ...data,
                                            ordersource_id: val?.id
                                        })
                                    }}
                                    value={orderSource?.filter(
                                        (option: any) => data?.ordersource_id == option.value
                                    )}
                                    options={orderSource}
                                ></Select>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Loại đơn</Label>
                            {data?.type === 'pos' ?
                                <div className="value-text">POS</div>:
                                <div className="value-text">Online</div>
                            }
                        </FormGroup>
                    </Col>
                    {data?.prescription_code &&
                    <Col md={4} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Kê đơn</Label>
                            <Link style={{color:'#5369f8'}} to={`/prescription/${data?.prescription_id}/view`} className="value-text">{data?.prescription_code}</Link>
                        </FormGroup>
                    </Col>}
                    {data?.prescription_id?.code &&
                    <Col md={4} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Kê đơn</Label>
                            <Link style={{color:'#5369f8'}} to={`/prescription/${data?.prescription_id?.id}/view`} className="value-text">{data?.prescription_id?.code}</Link>
                        </FormGroup>
                    </Col>}
                    <Col md={12} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Ghi chú</Label>
                            <InputGroup>
                                <Input type="text" value={data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder={type === 'view' && !data?.note ? '---' : "Nhập ghi chú"} />
                                
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <div>
                    <div className="modal-header">
                        <h5 className="modal-title" id="modal-action-title">
                            Thêm mới khách hàng
                        </h5>
                        <button onClick={()=> setIsOpen(false)} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                    </div>
                    <CustomerAdd closeModal={() => setIsOpen(false)} setDataFromExam={(val:any) => setData(val)} dataFromExam={data} from="exam"/>
                </div>
            </ModalPopup>
        </>
    )
}
export default OrderAddInfo